import { Body1, Body1Strong, makeStyles, mergeClasses, tokens, Tooltip } from '@fluentui/react-components';
import { DateLabel } from './DateLabel';

type TDue = { state: 'OVERDUE' | 'DUE_SOON'; days: number };

const useStyles = makeStyles({
  dangerText: {
    color: tokens.colorPaletteRedForeground1,
  },
  warningText: {
    color: tokens.colorPaletteMarigoldForeground2,
  },
});

const formatDays = (days: number) => `${days} ${days === 1 ? 'day' : 'days'}`;

const getDueCaption = ({ state, days }: TDue) => {
  if (state === 'OVERDUE') return `${formatDays(-days)} overdue`;
  return days ? `${formatDays(days)} left` : 'Due today';
};

type TDueDateLabelProps = { dueDate?: string; due?: TDue; variant?: 'default' | 'compact' };

const DueDateLabel = ({ dueDate, due, variant = 'default' }: TDueDateLabelProps) => {
  const compact = variant === 'compact';
  const Text = compact ? Body1 : Body1Strong;
  const classes = useStyles();
  if (!dueDate) return <Text className={compact ? 'text-neutralFg-3' : undefined}>-</Text>;
  const date = (
    <DateLabel short={compact} timeZone="UTC">
      {dueDate}
    </DateLabel>
  );
  if (!due) return <Text>{date}</Text>;
  // A close date reads as the time left; the date itself is one hover away.
  // w-fit: a flex column would stretch the text, and the arrow would point at the middle of the column.
  return (
    <Tooltip withArrow relationship="description" content={date}>
      <Text className={mergeClasses('w-fit', due.state === 'OVERDUE' ? classes.dangerText : classes.warningText)}>
        {getDueCaption(due)}
      </Text>
    </Tooltip>
  );
};

export { DueDateLabel };
export type { TDue };
